export default __webpack_public_path__ + "static/media/ic-issue.e1da9103.svg";